package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.ShiftCostsDto
import com.evoapps.evoshift.domain.model.ShiftCostBreakdown

class ShiftCostsMapper {

    fun toDomain(dto: ShiftCostsDto): ShiftCostBreakdown {
        return ShiftCostBreakdown(
            estimatedPayout = dto.estimatedPayout,
            employerCost = dto.employerCost,
            actualPayout = dto.actualPayout,
            otherCosts = dto.otherCosts,
            nightAllowance = dto.nightAllowance,
            employerContributions = dto.employerContributions,
            actualEmployerCost = dto.actualEmployerCost
        )
    }

    fun toDto(domain: ShiftCostBreakdown): ShiftCostsDto {
        return ShiftCostsDto(
            estimatedPayout = domain.estimatedPayout,
            employerCost = domain.employerCost,
            actualPayout = domain.actualPayout,
            otherCosts = domain.otherCosts,
            nightAllowance = domain.nightAllowance,
            employerContributions = domain.employerContributions,
            actualEmployerCost = domain.actualEmployerCost
        )
    }
}
